<!-- @名称：home.vue
@author: tengjd
@功能：1、重构首页
@时间：2023/3/28 -->

<style rel="stylesheet/scss" lang="scss">
  @charset "utf-8";
  .home {
    height: 100%;
    min-width: 1200px;
  }
  .home-content {
    margin-top: 2px;
    .el-carousel__container{
      min-width: 1200px;
    }
    .el-carousel__item{
      a{
        display: block;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;
        position: absolute;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .banner-text-con{
      width:1060px;
      margin: 0 auto;
      .banner-title{
        font-size: 32px;
        font-weight: 600;
        margin-top: 100px;
        color: #323233;
      }
      .banner-dec{
        font-size: 16px;
        color:rgba(0, 0, 0, 0.37);
        margin-top: 20px;
      }
    }
    .baogu{
      // background-image: url(../assets/images/fullbg1.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #323233;
    }
    .content-title{
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      padding-top: 64px;
      position: relative;
      top: 20px;
    }
    .content-title-bg{
      width: 600px;
      height: 68px;
      background-image: url(../assets/images/title_bg.png);
      background-size: cover;
      background-repeat: no-repeat;
      margin: 0 auto;
    }
    .content-title-bg2{
      width:360px;
      height: 68px;
      background-image: url(../assets/images/title_bg2.png);
      background-size: cover;
      background-repeat: no-repeat;
      margin: 0 auto;
    }
    .margin-b{
      margin-bottom: 64px;
    }
    .logotext-box {
      width:464px;
      height: 32px;
      margin: -16px auto 64px;
      display: flex;
      justify-content: space-between;
      img{
        width: 26px;
        height: 26px;
        position: relative;
        top: 8px;
        margin-right: 6px;
      }
      span{
        font-size: 16px;
        line-height: 32px;
      }
    }
    .content-cs{
      width: 1060px;
      margin: 0 auto;
      overflow: hidden;
      padding-bottom: 64px;
      .baogu-img{
        display: inline-block;
        width: 580px;
        height: 332px;
      }
      .caifu-img{
        display: inline-block;
        width: 500px;
        height: 500px;
      }
      .text-con{
        display: inline-block;
        width: 420px;
        overflow: hidden;
        
        .text-hd{
          font-size: 28px;
          line-height: 32px;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .text-bd{
          font-size: 16px;  
          line-height: 22px;
          color: #606060;
          margin-bottom: 20px;
        }
        .flex-box {
          height: 134px;
          margin-bottom: 24px;
          background: #F5F9FF;
          border-radius: 12px;
          padding: 0 30px;
          cursor: pointer;
          position: relative;
          .flex-title{
            padding-top: 18px;
          }
          img{
            width: 118px;
            height: 133px;
            position: absolute;
            top: 2px;
            right: 12px;
          }
        }
        .caifuActived{
          color: #fff;
          background: #71B4FF;
          .content-text{
            color: #fff;
          }
        }
      }
      .margin-l {
        margin-left: 125px;
        // padding-bottom: 40px;
      }
      .clear {
          clear: both;
      }
      .float-r{
        float: right;
      }
      .margin-l-text {
        width: 430px;
        margin-left: 50px;
        margin-bottom: 80px;
      }
    }
    .content-text{
      font-size: 16px;
      line-height: 22px;
      color: #606060;
      position: relative;
      z-index: 2;
    }
    .why-box{
      background-color: #F3F6FC;
      padding-bottom: 64px;
    }
    .flex-content{
      display: flex;
      justify-content: space-evenly;
      width: 1060px;
      margin: 0 auto;
      .flex-box{
        width: 320px;
        height: 360px;
        border-radius: 28px;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        .flex-title{
          font-size: 30px;
          font-weight: 500;
          margin-bottom: 20px;
        }
        .icon-homeContent{
          width: 110px;
          height: 110px;
          margin: 32px 0;
        }
      }
      .flex-box:hover{
        box-shadow: 8px 16px 45px 0px #C7DDFF;
      }
    }
    .guwen-nav{
      display: block;
      width: 837px;
      height: 180px;
      background: url(../assets/images/guwen_nav.png) no-repeat;
      background-size: cover;
      margin: 0 auto;
      &.fixed{
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
      }
    }

  }
  

</style>
<template>
  <div class="home">
    <Head :selectindex="selectindex"></Head>
    <div class="content home-content">
      <el-carousel height="380px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <a href="javaScript:;" :style="{backgroundImage: 'url(' + item.imgUrl + ')'}" :key="item.id">
            <div class="banner-text-con">
              <!-- <p class="banner-title">保卫财富 守护家人</p>
              <p class="banner-dec">专注财富机构的保险赋能</p> -->
            </div>
          </a>
           <!-- <img :src="item.imgUrl" alt="" :key="item.id"> -->
        </el-carousel-item>
      </el-carousel>
      <div class="content-box baogu">
        <div class="content-title">致力成为“买方保顾”第一品牌 </div>
        <div class="content-title-bg"></div>
        <div class="logotext-box">
          <div>
            <img src="../assets/images/logotext1.png" alt="">
            <span>基础风险保障</span>
          </div>
          <div>
            <img src="../assets/images/logotext2.png" alt="">
            <span>资产配置规划</span>
          </div>
          <div>
            <img src="../assets/images/logotext3.png" alt="">
            <span>家庭财富保全</span>
          </div>

        </div>
        <div class="content-cs clear">
          <img class="baogu-img" src="../assets/images/baogu.png" alt="" srcset="">
          <div class="text-con float-r">
            <div class="text-hd">多维度、一站式保障方案</div>
            <p class="text-bd">通过保险科普、精细化运营和一站式服务，为客户提供涵盖基础风险保障、资产配置规划、家庭财富保全等维度的综合保障解决方案。</p>
            <p class="text-bd">打造“投、顾、教”三大核心能力，通过深入洞察分析国人在保险保障及相关衍生领域的体验痛点或服务诉求，打造针对性的解决方案。</p>
          </div>
        </div>
      </div>
      
      <div class="content-box linian-content">
        <div class="content-title">我们的理念 “保卫财富，守护家人”</div>
        <div class="content-title-bg margin-b"></div>
        <div class="content-cs clear">
          <div class="text-con">
            <div class="flex-box" @mouseover="changeBg(1)" :class="caifuActived == 1 ? 'caifuActived' : ''">
              <h4 class="text-hd flex-title">人身风险</h4>
              <p class="flex-text content-text">提供疾病、意外、人寿等基础风险防范方案，帮助客户实现人身风险全方位保障。</p>
              <img class="caifu-img" src="../assets/images/caifubg1.png" alt="">
            </div>
            <div class="flex-box" @mouseover="changeBg(2)" :class="caifuActived == 2 ? 'caifuActived' : ''">
              <h4 class="text-hd flex-title">规划风险</h4>
              <p class="flex-text content-text">提供教育、养老、旅游等未来开支规划，帮助客户实现财富稳步积累。</p>
              <img class="caifu-img" src="../assets/images/caifubg2.png" alt="">
            </div>
            <div class="flex-box" @mouseover="changeBg(3)" :class="caifuActived == 3 ? 'caifuActived' : ''">
              <h4 class="text-hd flex-title">保全风险</h4>
              <p class="flex-text content-text">提供子女传承、财产隔离等家族财富保全方案，帮助客户实现财富代代相传。</p>
              <img class="caifu-img" src="../assets/images/caifubg3.png" alt="">
            </div>
          </div>
          <img class="float-r caifu-img" :src="caifuImg" alt="" srcset="">
        </div>
      </div>
      <div class="content-box why-box">
        <div class="content-title">为什么选择我们</div>
        <div class="content-title-bg2 margin-b"></div>
        <div class="flex-content">
          <div class="flex-box">
            <img class="icon-homeContent" src="../assets/images/whybg1.png" alt="">
            <h4 class="flex-title">大牌合作</h4>
            <p class="flex-text content-text">联合多家保险公司<br>产品丰富、严格筛选</p>
          </div>
          <div class="flex-box">
            <img class="icon-homeContent" src="../assets/images/whybg2.png" alt="">
            <h4 class="flex-title">量身定制</h4>
            <p class="flex-text content-text">专业团队定制方案<br>保障全面、性价比高</p>
          </div>
          <div class="flex-box">
            <img class="icon-homeContent" src="../assets/images/whybg3.png" alt="">
            <h4 class="flex-title">长期服务</h4>
            <p class="flex-text content-text">1v1专属顾问服务<br>投保放心、理赔安心</p>
          </div>
        </div>
      </div>
      <a class="guwen-nav" :class="guwenNav ? 'fixed' : ''" href="https://i.yingxin.cn/activity.html#/reservation?channelId=72&userId=127367&sceneId=1" target="_blank"></a>
    </div>
    <Foot style="padding-bottom: 130px;"></Foot>
  </div>
</template>

<script>
  import Head from '../components/headercontent'
  import Foot from '../components/footercontent'
  import Service from '../common/service'
  export default {
    name: 'home',
    data() {
      return {
        selectindex: 0,
        caifuImg: require('../assets/images/caifu1.png'),
        bannerList: [],
        guwenNav: false,
        caifuActived: 1,
      }
    },
    created() {
      this.getbanner(1);

    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      // 移除监听
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      afterLoad(anchorLink, index) {
        
      },
      changeBg(index) {
        this.caifuActived = index;
        this.caifuImg = require('../assets/images/caifu' + index + '.png');
        // this.selectindex = index;
      },
      getbanner(id) {
        Service.banner().getbanner({}, id).then(response => {
          this.bannerList = response.data
        }, err => {
          console.log(err);
        });
      },
      handleScroll() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 获取滚动距离
        const bottomOffset = document.documentElement.scrollHeight - (scrollTop + window.innerHeight) // 距离底部的距离
        if (scrollTop > 400) {
          // 滚动距离大于 600px，且距离底部还有超过 100px，固定导航在页面底部
          // console.log('滚动距离大于 600px，且距离底部还有超过 100px，固定导航在页面底部')
          this.guwenNav = true
        } else {
          // 取消导航的固定
          // console.log('取消导航的固定')
          this.guwenNav = false
        }
      },
    },
    beforeDestroy() {
      
    },
    components: {
      Head,
      Foot,
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/views/home.vue